module.exports = __webpack_public_path__ + "img/ic_place.fe857b02.svg";